import React, { useState } from 'react';
import { Tabs, Button } from 'antd';
import { SafetyCertificateOutlined, TeamOutlined, PlusOutlined } from '@ant-design/icons';
import { useQuery } from 'react-apollo';

import SLAConfigTable from './SLAConfigTable';
import TeamsTable from './TeamsTable';

import useResponsiveTask from '../../hooks/useResponsiveTask';
import GET_SLA_CONFIGS from '../../../../../core/GraphQl/Queries/GET_SLA_CONFIGS';

import { space, radius, shadow } from '../../configs/designTokens';
import { taskTypes } from '../../configs/task.config';

const { TabPane } = Tabs;

const TaskAdmin = () => {
  const { isMobile } = useResponsiveTask();
  const [activeTab, setActiveTab] = useState('teams');
  const [addingNew, setAddingNew] = useState(false);
  const [createTeamVisible, setCreateTeamVisible] = useState(false);

  const { data: slaData, loading: slaLoading } = useQuery(GET_SLA_CONFIGS, {
    fetchPolicy: 'cache-and-network',
  });

  const slaConfigs = slaData?.slaConfigs || [];
  const hasAvailableTypes = taskTypes.some(
    (type) => !slaConfigs.some((c) => c.requestType === type)
  );

  return (
    <div style={{ marginTop: space[2] }}>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        size={isMobile ? 'small' : 'default'}
        tabBarExtraContent={
          activeTab === 'sla'
            ? !addingNew && hasAvailableTypes && (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  className="task-board-header__primary-btn"
                  onClick={() => setAddingNew(true)}
                  size="small"
                >
                  Add SLA
                </Button>
              )
            : activeTab === 'teams' && (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  className="task-board-header__primary-btn"
                  onClick={() => setCreateTeamVisible(true)}
                  size="small"
                >
                  Create Team
                </Button>
              )
        }
        style={{
          background: '#fff',
          borderRadius: radius.xl,
          padding: isMobile ? space[3] : space[4],
          boxShadow: shadow.sm,
        }}
      >
        <TabPane
          tab={
            <span>
              <TeamOutlined /> Teams
            </span>
          }
          key="teams"
        >
          <TeamsTable createModalVisible={createTeamVisible} setCreateModalVisible={setCreateTeamVisible} />
        </TabPane>
        <TabPane
          tab={
            <span>
              <SafetyCertificateOutlined /> SLA Configuration
            </span>
          }
          key="sla"
        >
          <SLAConfigTable
            slaConfigs={slaConfigs}
            loading={slaLoading}
            addingNew={addingNew}
            setAddingNew={setAddingNew}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default TaskAdmin;
